import { AppShell } from "@mantine/core";
import AnnouncementBar from "./AnnouncementBar";
import PageHeader from "./PageHeader";
import PageFooter from "./PageFooter";
import { OrganizationJsonLd, LocalBusinessJsonLd, WebSiteJsonLd } from "./seo";

function PageShell(props) {
  return (
    <AppShell
      fixed={false}
      padding={0}
      styles={{
        main: {
          paddingLeft: 0,
          paddingRight: 0,
          minHeight: "100vh",
          backgroundColor: "#fff",
        },
      }}
      footer={<PageFooter />}
      header={
        <>
          <AnnouncementBar />
          <PageHeader />
        </>
      }
    >
      <OrganizationJsonLd />
      <LocalBusinessJsonLd />
      <WebSiteJsonLd />
      {props.children}
    </AppShell>
  );
}

export default PageShell;
